import axios from 'axios'
import { TourEvent } from './_models'

const API_URL = process.env.REACT_APP_API_URL || ''

export const createTourEvent = async (eventData: Partial<TourEvent>, language: string) => {
  // Always send translations array
  const translations = [
    {
      language,
      title: eventData.title,
      description: eventData.description,
      content: eventData.content,
    },
  ];
  const payload = { ...eventData, translations };
  try {
    const response = await axios.post(`${API_URL}/tour-events`, payload)
    return response.data
  } catch (error) {
    throw error
  }
}

export const updateTourEvent = async (eventId: string, eventData: Partial<TourEvent>, language: string) => {
  // Always send translations array
  const translations = [
    {
      language,
      title: eventData.title,
      description: eventData.description,
      content: eventData.content,
    },
  ];
  const payload = { ...eventData, translations };
  try {
    const response = await axios.patch(`${API_URL}/tour-events/${eventId}`, payload)
    return response.data
  } catch (error) {
    throw error
  }
}

export const getTourEventsByTourId = async (tourId: string, language: string) => {
  try {
    const response = await axios.get(`${API_URL}/tour-events/by-tour/${tourId}`, {
      params: { language },
    })
    return response.data
  } catch (error) {
    throw error
  }
}

export const deleteTourEvent = async (eventId: string) => {
  try {
    const response = await axios.delete(`${API_URL}/tour-events/${eventId}`)
    return response.data
  } catch (error) {
    throw error
  }
}

export const deleteAllTourEvents = async (tourId: string) => {
  try {
    const response = await axios.delete(`${API_URL}/tour-events/by-tour/${tourId}`)
    return response.data
  } catch (error) {
    throw error
  }
}

// Add an empty export to ensure this file is treated as a module
export {} 